const PUBLIC = process.env.PUBLIC_URL || '';

export const LOGO = `${PUBLIC}/images/logo.png`;
export const HERO_POSTER = `${PUBLIC}/images/hero-poster.jpg`;
export const HERO_VIDEO = `${PUBLIC}/hero-video.mp4`;
export const MISSION_1 = `${PUBLIC}/images/mission-1.jpg`;
export const MISSION_2 = `${PUBLIC}/images/mission-2.jpg`;

const galleryPath = (n) => `${PUBLIC}/images/gallery/${String(n).padStart(2, '0')}.jpg`;

export const galleryImages = Array.from({ length: 24 }, (_, i) => galleryPath(i + 1));
